import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BlockButton } from '@plone/volto-slate/editor/ui';
import { default as Icon } from '@plone/volto/components/theme/Icon/Icon';

import { composeSchema } from '@plone/volto/helpers/Extensions';
import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import { defaultStylingSchema } from '@kitconcept/volto-light-theme/components/Blocks/schema';

import DescriptionsmIcon from '../../theme/icons/description_sm.svg';
import DescriptionIcon from '../../theme/icons/description.svg';
import GreenTIcon from '../../theme/icons/green_t_icon.svg';
import Heading2Icon from '../../theme/icons/heading2.svg';
import Heading3Icon from '../../theme/icons/heading3.svg';
import Heading4Icon from '../../theme/icons/heading4.svg';
import { alignStyleSchema } from '../alignStyleSchema';
import { alignTextStyleSchema } from '../alignTextStyleSchema';
import { alignItemsStyleSchema } from '../alignItemsStyleSchema';
import { containerStyleSchema } from '../containerStyleSchema';
import { paddingVerticalStyleSchema } from '../paddingVerticalStyleSchema';
import { anchorStyleSchema } from '../anchorStyleSchema';

import { DESCRIPTION, DESCRIPTIONSM } from './constants';
import DescriptionElement from './DescriptionPlugin/DescriptionElement';
import { buildStyleObjectFromData } from '@plone/volto/helpers/Blocks/Blocks';
import { isObject } from 'lodash';
export function installExtraPlugins(config) {
  config.settings.slate.buttons[DESCRIPTION] = (props) => (
    <BlockButton
      format={DESCRIPTION}
      icon={DescriptionIcon}
      title="Description"
      {...props}
    />
  );

  config.settings.slate.elements[DESCRIPTION] = DescriptionElement;

  config.settings.slate.buttons[DESCRIPTIONSM] = (props) => (
    <BlockButton
      format={DESCRIPTIONSM}
      icon={DescriptionsmIcon}
      title="Small Description"
      {...props}
    />
  );
  config.settings.slate.elements[DESCRIPTIONSM] = (props) => (
    <DescriptionElement {...props} size="size-small" />
  );

  return config;
}

export function overrideIcons(config) {
  const { slate } = config.settings;
  slate.buttons['heading-two'] = (props) => (
    <BlockButton icon={Heading2Icon} title="Heading 2" format="h2" {...props} />
  );
  slate.buttons['heading-three'] = (props) => (
    <BlockButton icon={Heading3Icon} title="Heading 3" format="h3" {...props} />
  );
  slate.buttons['heading-four'] = (props) => (
    <BlockButton icon={Heading4Icon} title="Heading 4" format="h4" {...props} />
  );
  return config;
}

export function installStyledSlate(config) {
  const { slate } = config.settings;

  slate.styleMenu.inlineStyles = [
    {
      cssClass: 'primary-color-text',
      label: <FormattedMessage id="Green color" defaultMessage="Green color" />,
      icon: (props) => <Icon name={GreenTIcon} size="24px" />,
    },
  ];
  // slate.styleMenu.blockStyles = [
  //   {
  //     cssClass: 'centered-text',
  //     label: <FormattedMessage id="Centered" defaultMessage="Centered" />,
  //     icon: (props) => <Icon name={GreenTIcon} size="24px" />,
  //   },
  // ];

  config.blocks.blocksConfig[COLUMNSBLOCK] = {
    ...config.blocks.blocksConfig[COLUMNSBLOCK],
    schemaEnhancer: composeSchema(
      config.blocks.blocksConfig[COLUMNSBLOCK].schemaEnhancer,
      defaultStylingSchema,
      alignStyleSchema,
      alignItemsStyleSchema,
      paddingVerticalStyleSchema,
      anchorStyleSchema,
    ),
  };
  config.blocks.blocksConfig.gridBlock = {
    ...config.blocks.blocksConfig.gridBlock,
    schemaEnhancer: composeSchema(
      config.blocks.blocksConfig.gridBlock.schemaEnhancer,
      alignStyleSchema,
      alignTextStyleSchema,
      containerStyleSchema,
    ),
  };

  config.blocks.blocksConfig.teaser = {
    ...config.blocks.blocksConfig.teaser,
    schemaEnhancer: composeSchema(
      config.blocks.blocksConfig.teaser.schemaEnhancer,
      alignTextStyleSchema,
      paddingVerticalStyleSchema,
      anchorStyleSchema,
    ),
  };
  const SlateView = config.blocks.blocksConfig.slate.view;
  const SlateEdit = config.blocks.blocksConfig.slate.edit;

  config.blocks.blocksConfig.slate = {
    ...config.blocks.blocksConfig.slate,
    view: (props) => (
      <div className={props.className} style={props.style} id={props.id}>
        <SlateView {...props} />
      </div>
    ),
    edit: (props) => {
      const style = buildStyleObjectFromData(props.data);
      return (
        <div className={props.className} style={isObject(style) ? style : {}}>
          <SlateEdit {...props} />
        </div>
      );
    },
    schemaEnhancer: composeSchema(
      config.blocks.blocksConfig.slate.schemaEnhancer,
      alignTextStyleSchema,
      containerStyleSchema,
      anchorStyleSchema,
    ),
  };

  return config;
}

export const removeUnneededSlate = (config) => {
  const { slate } = config.settings;

  slate.toolbarButtons = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'clearformatting',
    'link',
    'separator',
    'heading-two',
    'heading-three',
    'heading-four',
    DESCRIPTION,
    DESCRIPTIONSM,
    'separator',
    'bulleted-list',
    'numbered-list',
    'styleMenu',
  ];
  return config;
};
